import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { WA_PLAIN } from "@/lib/constants";

const LINKS = [
  { label: "Beranda", href: "#beranda" },
  { label: "Layanan", href: "#layanan" },
  { label: "Keunggulan", href: "#keunggulan" },
  { label: "Area Layanan", href: "#area-layanan" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontak", href: "#kontak" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/75 border-b border-ink/10">
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-5 lg:px-12 h-14 lg:h-20">
        <a href="#beranda" data-testid="nav-logo" className="font-display font-extrabold text-lg tracking-tight">
          SANJAYA<span className="text-brand-ink">.</span>SERVICE
        </a>

        <div className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="font-mono text-xs uppercase tracking-[0.15em] text-ink/60 hover:text-brand-ink transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href={WA_PLAIN}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-mobile-wa-icon"
            aria-label="Chat WhatsApp Sanjaya Service"
            className="sm:hidden inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#25D366] text-white"
          >
            <MessageCircle size={18} strokeWidth={2.5} />
          </a>
          <a
            href={WA_PLAIN}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-button"
            aria-label="Hubungi Sanjaya Service via WhatsApp"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-brand px-5 py-2.5 font-display font-bold text-sm text-black hover:bg-ink hover:text-white transition-colors duration-300"
          >
            <MessageCircle size={16} strokeWidth={2.5} />
            Hubungi Kami
          </a>
          <button
            data-testid="nav-mobile-menu-button"
            aria-label={open ? "Tutup menu navigasi" : "Buka menu navigasi"}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            className="lg:hidden text-ink/80 p-2"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden overflow-hidden border-t border-ink/10 bg-white/95"
          >
            <div className="flex flex-col px-6 py-6 gap-5">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`nav-mobile-link-${l.href.slice(1)}`}
                  onClick={() => setOpen(false)}
                  className="font-display font-bold text-2xl uppercase tracking-tight text-ink/80"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={WA_PLAIN}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-mobile-whatsapp-button"
                className="mt-2 inline-flex w-fit items-center gap-2 rounded-full bg-brand px-6 py-3 font-display font-bold text-black"
              >
                <MessageCircle size={18} strokeWidth={2.5} />
                Hubungi Kami
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
